import Swal from "sweetalert2";

export const showLoadingAlert = (message = "") => {
  Swal.fire({
    title: "Loading!",
    icon: "info",
    text: message,
    allowOutsideClick: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

export const showSuccessAlert = (message = "") => {
  return Swal.fire({
    icon: "success",
    title: "Success",
    text: message,
    allowOutsideClick: false,
    allowEscapeKey: false,  
    confirmButtonText: "OK",
    confirmButtonColor: "#254171",
    timer: null 
  });
};

export const showLoaderAlert = (message = "") => {
  return Swal.fire({
    title: "Loading!",
    text: message,
    icon: "info",
    confirmButtonColor: "#254171",
    showConfirmButton: false,
    timer: null,
    willOpen: () => {
      Swal.showLoading();
    },
  });
};

export const showErrorAlert = (message = "") => {
  return Swal.fire({
    icon: "error",
    title: "Error",
    text: message,
    allowOutsideClick: false,
    allowEscapeKey: false,
    confirmButtonText: "OK",
    confirmButtonColor: "#254171",
    timer: null
  });
};

export const showInfoAlert = (message = "") => {
  return Swal.fire({
    title: "Info!",
    icon: "info",
    text: message,
    confirmButtonColor: "#57aedd",
    timer: null
  });
};
